<template>
<m-pageframe
    title="Test Messenger Layout"
>
    <m-messenger-layout>
        <template v-slot:left>
            <m-conversation-summaries
                ref="summary_pane"
            >
            </m-conversation-summaries>
        </template>

        <m-conversation
            ref="conversation_pane"
        />
    </m-messenger-layout>
</m-pageframe>
</template>

<script>
const TestData = require('@/js/TestData.js');

export default {
    data() {
        return {
        }
    },
    mounted () {

        let summaries = TestData.getConversationSummariesBig();
        let selected_conversation_summary = summaries.get(0).getConversationId();

        this.$refs['summary_pane'].update(summaries);
        this.$refs['summary_pane'].setSelectedConversationId(selected_conversation_summary);
        
        this.$refs['conversation_pane'].update(TestData.getConversationBig());
    },
}
</script>

<style lang="scss" scoped>

</style>